import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import WebbLoader from "./webb-loader";

import { GetAuthUser } from "../services/user-accounts";
import { GetRoomText } from "../services/user-accounts";

export default function RoomTextListModule(props) {

  const asset = GetAuthUser();
  const { id } = useParams();

  const [loading,setLoading]=useState(true);
  const [data,setData]=useState([]);

  useEffect( () => {
    if (asset){
      const fetchData = async() => {
        setData( (await GetRoomText(JSON.stringify({
          body: {rmid: id}, user:{}
        }))).data);
        setLoading(false);
      }
      fetchData()
    } else {}
  },[asset.usid]);

  if (loading) return ( <> <WebbLoader /> </>)

  return (
    <>
      {console.log (data)}
      <div className="card p-3 rounded-wd border bg-white" 
      style={{height:"60vh", overflowY:'auto'}}
      >

      {data && data.map((item, i) => (
        <div className="d-flex mb-3" key={i}>

          <div className="me-auto">
            <p className="small m-0 p-0 text-muted">
              {item.name.data.name}</p>
            <p className="m-0 p-0">{item.text}</p>
          </div>
        
          <div className="text-end" style={{width:'fit-content'}}>
            <p className="small m-0 p-0">{(item.crts).substr(0,10)}, {(item.crts).substr(11,5)}</p>
          </div>
        </div>
      ))}
      </div>

    </>
  )
}